import React, { useEffect, useState } from 'react';
import './layout.css';
import { GetDataUser } from "../../util/GetDataUser";
import { FaBars, FaCamera, FaChevronLeft, FaDoorOpen, FaPaperclip, FaRobot, FaTruckLoading } from 'react-icons/fa';
import { FaUsers, FaShoppingCart } from "react-icons/fa";
import { FaBoxesPacking, FaCalendar, FaGears, FaKey, FaXmark } from "react-icons/fa6";
import { FaBoxes } from "react-icons/fa";
import { BsInboxesFill } from "react-icons/bs";
import ModalAlterarSenha from '../Modals/Usuario/ModalAlterarSenha';
import LogoBranco from '../../imgs/logo_branco.png';
import { MdBlockFlipped, MdFactCheck } from "react-icons/md";
import { eTipoUsuario } from '../../enum/eTipoUsuario';
import { api } from '../api/api';
import { Alert, AlertErro } from '../../util/Alertas';
import { HiOutlineDocumentReport } from 'react-icons/hi';

const STORAGE_SIDEBAR = 'sidebarRecolhida';

function lerSidebarRecolhida() {
  try {
    return window.localStorage.getItem(STORAGE_SIDEBAR) === '1';
  } catch {
    return false;
  }
}

function Layout({ children, Tela, Icon }) {
  const usuario = GetDataUser();
  const [show, setShow] = useState(false);
  const [recolhida, setRecolhida] = useState(lerSidebarRecolhida);
  const [menuMobileAberto, setMenuMobileAberto] = useState(false);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_SIDEBAR, recolhida ? '1' : '0');
    } catch { }
  }, [recolhida]);

  useEffect(() => {
    document.body.classList.toggle('menu-mobile-aberto', menuMobileAberto);
  }, [menuMobileAberto]);

  function toggleMenu() {
    if (window.matchMedia('(max-width: 991.98px)').matches)
      setMenuMobileAberto(!menuMobileAberto);
    else
      setRecolhida(!recolhida);
  }

  function logout() {
    window.localStorage.clear();
    window.location.href = "/login";
  }

  function getNomeTipoUser() {
    switch (usuario.TipoUsuario) {
      case 1:
        return "Vendedor"
      case 2:
        return "Administrador"
      case 3:
        return "Vendedor/Motorista"
      default:
        return ""
    }
  }

  function getIniciais() {
    const partes = (usuario?.UsuarioNome ?? '').trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return '?';
    return (partes[0][0] + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
  }

  const runRobotPix = () => {
    Alert('Robô foi iniciado')
    api.get('api/WebHook/web-hook-payment-pix', res => {
      Alert(res.data)
    }, err => {
      AlertErro(err)
    })
  }

  const naoVendedor = usuario.role !== eTipoUsuario.Vendedor;
  const naoMotorista = usuario.role !== eTipoUsuario.MotoristaVendedor;

  const grupos = [
    {
      titulo: 'Comercial',
      itens: [
        { href: 'cliente', texto: 'Meus Clientes', icone: <FaUsers />, visivel: true },
        { href: 'pedido', texto: 'Pedidos por Cliente', icone: <FaShoppingCart />, visivel: true },
        { href: 'gestao', texto: 'Gestão de Pedidos', icone: <FaGears />, visivel: naoMotorista },
      ]
    },
    {
      titulo: 'Logística',
      itens: [
        { href: 'gestao/motorista-vendedor', texto: 'Gestão Vendedor/Motorista', icone: <FaTruckLoading />, visivel: naoVendedor },
        { href: 'codigo-barras', texto: 'Confirmar Entrega', icone: <FaCamera />, visivel: naoVendedor },
        { href: 'pedido/arquivos', texto: 'Anexos Pedidos', icone: <FaPaperclip />, visivel: naoMotorista && usuario.IsMaster },
      ]
    },
    {
      titulo: 'Cadastros',
      itens: [
        { href: 'produtos', texto: 'Produtos', icone: <FaBoxes />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'materia-prima', texto: 'Matéria Prima', icone: <BsInboxesFill />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'deposito', texto: 'Depósitos', icone: <FaBoxesPacking />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'usuarios', texto: 'Usuários', icone: <FaUsers />, visivel: naoMotorista && usuario.IsMaster },
      ]
    },
    {
      titulo: 'Financeiro',
      itens: [
        { href: 'baixa-boleto', texto: 'Baixa Boleto', icone: <MdFactCheck />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'bloquear-clientes', texto: 'Bloquear Clientes', icone: <MdBlockFlipped />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'fechamento', texto: 'Fechamento Mês', icone: <FaCalendar />, visivel: naoMotorista && usuario.IsMaster },
        { href: 'relatorio-recibos', texto: 'Relatório Recibos', icone: <HiOutlineDocumentReport />, visivel: usuario.IsMaster },
        { onClick: runRobotPix, texto: 'Rodar Robô Pix', icone: <FaRobot />, visivel: usuario.IsMaster },
      ]
    },
  ];

  const caminhoAtual = window.location.pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
  const isAtivo = href => href && (caminhoAtual === href || (href === 'cliente' && caminhoAtual === ''));

  return (
    <div className={`app-shell ${recolhida ? 'sidebar-recolhida' : ''} ${menuMobileAberto ? 'menu-aberto' : ''}`}>
      <ModalAlterarSenha show={show} setShow={setShow} />

      <aside className="app-sidebar">
        <div className="app-sidebar-brand">
          <img src={LogoBranco} alt="Carvão Kompleto" />
          <button type="button" className="app-sidebar-fechar" onClick={() => setMenuMobileAberto(false)} aria-label="Fechar menu">
            <FaXmark size={20} />
          </button>
        </div>

        <nav className="app-sidebar-nav">
          {grupos.map(grupo => {
            const itens = grupo.itens.filter(x => x.visivel);
            if (itens.length === 0) return null;
            return (
              <div className="app-nav-grupo" key={grupo.titulo}>
                <span className="app-nav-titulo">{grupo.titulo}</span>
                {itens.map(item => item.href
                  ? <a key={item.texto} href={item.href} title={item.texto} className={`app-nav-item ${isAtivo(item.href) ? 'ativo' : ''}`}>
                    <span className="app-nav-icone">{item.icone}</span>
                    <span className="app-nav-texto">{item.texto}</span>
                  </a>
                  : <button key={item.texto} type="button" onClick={item.onClick} title={item.texto} className="app-nav-item">
                    <span className="app-nav-icone">{item.icone}</span>
                    <span className="app-nav-texto">{item.texto}</span>
                  </button>
                )}
              </div>
            );
          })}
        </nav>

        <div className="app-sidebar-footer">
          <button type="button" className="app-nav-item" onClick={() => setShow(true)} title="Trocar Senha">
            <span className="app-nav-icone"><FaKey /></span>
            <span className="app-nav-texto">Trocar Senha</span>
          </button>
          <button type="button" className="app-nav-item" onClick={logout} title="Sair">
            <span className="app-nav-icone"><FaDoorOpen /></span>
            <span className="app-nav-texto">Sair</span>
          </button>
        </div>
      </aside>

      <div className="app-overlay" onClick={() => setMenuMobileAberto(false)} />

      <div className="app-main">
        <header className="app-topbar">
          <div className="app-topbar-esquerda">
            <button type="button" className="app-topbar-toggle" onClick={toggleMenu} aria-label="Alternar menu">
              <FaBars size={18} />
            </button>
            <div className="app-topbar-titulo">
              {Icon && <span className="app-topbar-icone">{Icon}</span>}
              <div>
                <span className="app-breadcrumb">Carvão Kompleto</span>
                <h1>{Tela}</h1>
              </div>
            </div>
          </div>

          <div className="app-topbar-direita">
            <button type="button" onClick={() => window.history.go(-1)} className="app-btn-voltar" title="Voltar">
              <FaChevronLeft size={12} /> <span>Voltar</span>
            </button>
            <div className="app-usuario">
              <span className="app-avatar">{getIniciais()}</span>
              <div className="app-usuario-info">
                <strong>{usuario?.UsuarioNome}</strong>
                <small>{getNomeTipoUser()}</small>
              </div>
            </div>
            <button type="button" className="app-topbar-sair" onClick={logout} title="Sair">
              <FaDoorOpen size={18} />
            </button>
          </div>
        </header>

        <main className="app-conteudo">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
